// Copyright ©️ 2026 eVolve MEP, LLC

import { createModalRegistry } from 'components/Mantine/Modals/createModalRegistry';
import { WorkOrderItemModal } from 'modules/Shop/WorkOrders/WorkOrderDetail/Items/WorkOrderItemModal';

export const [WorkOrderDetailModalProvider, , useWorkOrderDetailTrackedModal] = createModalRegistry({
  workOrderItemModal: WorkOrderItemModal,
});
